import { Helmet } from 'react-helmet';
import { toSlug } from '@medifind/router';
import { isPrerender } from '@medifind/utils';
import { htmlToLDJSON } from '@medifind/utils';
export const DoctorJsonLd = ({ doctor }) => {
  const { personId, name, address, specialties, image, biography, phone } = doctor || {};
  // const scoreGenerator = conditions => {
  //   var topScore = null;
  //   var x = conditions
  //     .sort((a, b) => b.score - a.score)
  //     .map((d, i) => {
  //       if (topScore == null) topScore = d.score;
  //       var weight = 2 / (1 + Math.exp(-0.08 * (d.score - topScore)));
  //       return { score: d.score * weight, weight: weight };
  //     })
  //     .reduce(
  //       (t, a, i) => {
  //         t.totalWeight += a.weight;
  //         t.totalScore += a.score;
  //         return t;
  //       },
  //       { totalScore: 0, totalWeight: 0 }
  //     );
  //   return x.totalScore / x.totalWeight;
  // };
  const addressArray = [];
  if (address.addressLine1) {
    addressArray.push(address.addressLine1);
  }
  if (address.addressLine2) {
    addressArray.push(address.addressLine2);
  }
  if (address.addressLine3) {
    addressArray.push(address.addressLine3);
  }
  return (
    <Helmet defer={!isPrerender}>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'http://schema.org/',
          '@type': 'Physician',
          name: name,
          description: htmlToLDJSON(biography),
          url: `${process.env.NX_LOCAL_HOST}/doctors/${toSlug(name)}/${personId}`,
          ...(address.fidelity === 1
            ? {
                address: {
                  '@type': 'PostalAddress',
                  addressLocality: address.city,
                  addressRegion: address.stateProvinceCode,
                  postalCode: address.zip,
                  streetAddress: addressArray.join(', '),
                },
              }
            : {}),
          ...(image ? { image: `${doctor.image}-350x350.png` } : {}),
          ...(specialties && specialties.length > 0
            ? {
                medicalSpecialty: {
                  '@type': 'MedicalSpecialty',
                  name: specialties[0],
                  url: `${process.env.NX_LOCAL_HOST}specialty/${toSlug(specialties[0])}`,
                },
              }
            : {}),
          ...(phone ? { telephone: phone } : {}),
          // aggregateRating: {
          //   '@context': 'http://schema.org',
          //   '@type': 'aggregateRating',
          //   name: 'MediFind',
          //   description:
          //     "The MediFind rating is based on empirical evidence of what the provider has researched and treated. These ratings are aggregated and compared to their peers to provide an informative score for a provider's knowledge.",
          //   ratingValue: 5
          // }
          // hospitalAffiliation: {
          //   '@type': 'Hospital',
          //   name: 'University of Maryland St. Joseph Medical Center',
          //   address: 'Towson, MD',
          //   telephone: '(410) 337-1000',
          //   image: 'no_image.jpg'
          // }
        })}
      </script>
    </Helmet>
  );
};
